var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBankTransferGrey = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.156 12h11.688M3.531 5.125V12M6.281 5.125V12M9.719 5.125V12M12.469 5.125V12M14.531 5.125H1.47l6.027-3.96a.855.855 0 0 1 1.008 0l6.027 3.96Z",
  stroke: "#5A687B",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export { SvgBankTransferGrey as ReactComponent };
export default __webpack_public_path__ + "assets/media/bank-transfer-grey.ff7d41ca37755d6055a688658af79160.svg";